import OfflineWarning, { OFFLINE_WARNING_ENTRYPOINT_ID } from '.';

export default {
    Component: OfflineWarning,
    id: OFFLINE_WARNING_ENTRYPOINT_ID,
};
